export default __webpack_public_path__ + "static/media/fiscal.86f61fc2.png";